import React, { useContext } from 'react'

import PanelHeader from '../../../elem/panel/PanelHeader'
import MapHeaderControls from './MapHeaderControls'
import { MapControlContext } from './MapControlContext'
import ExpandButton from '../../../elem/list/ExpandButton'
import { FaAngleUp, FaAngleDown } from 'react-icons/fa'
import CollapseButton from '../../../elem/list/CollapseButton'
import { PanelStyleContext } from '../../../elem/panel/PanelStyleContext'

const ExplorerMapHeader = () => {
    const { isCollapsed, setCollapsed } = useContext(MapControlContext)
    const { isExpanded, setIsExpanded } = useContext(PanelStyleContext)

    return (
        <PanelHeader extraClass={`mapPanelHeader`}>
            <div className="mapHeaderText">Map</div>
            <div className="panelHeaderControls">
                <div className="panelHeaderIconWrapper">
                    <MapHeaderControls />
                    {isExpanded ? null : (
                        <CollapseButton
                            name={`Map`}
                            isCollapsed={isCollapsed}
                            setCollapsed={setCollapsed}
                        />
                    )}
                    <ExpandButton
                        name={`Map`}
                        isExpanded={isExpanded}
                        setIsExpanded={setIsExpanded}
                    />
                </div>
            </div>
        </PanelHeader>
    )
}

export default ExplorerMapHeader
